import React, { useState, useEffect } from 'react';
import PageLayout from '../common/PageLayout';
import { LocliazeTextCacheDatabase, LocliazeImageCacheDatabase } from '../utils/api/productApi';
import { handleImportProcess } from '../utils/fileHandlers/importHandler';
import '../css/Step1.css';

function LocalizeDatabase() {
    const [error, setError] = useState('');
    const [statusMessage, setStatusMessage] = useState('');
    const [isConverting, setIsConverting] = useState(false);
    const [animatedText, setAnimatedText] = useState('Localizing Text and Image Cache');
    const [serverLogs, setServerLogs] = useState([]);

    useEffect(() => {
        if (isConverting) {
            let currentIndex = 0;
            const fullText = 'Localizing Text and Image Cache';
            const dots = '...';

            const timer = setInterval(() => {
                const numDots = (currentIndex % 4);  // 0에서 3까지 순환
                setAnimatedText(`${fullText}${dots.slice(0, numDots)}`);
                currentIndex++;
            }, 500);  // 타이머 간격을 500ms로 조정

            return () => clearInterval(timer);
        } else {
            setAnimatedText('Waiting...');  // converting 끝나면 원래 텍스트로
        }
    }, [isConverting]);

    const handleConvert = async () => {
        setError("");
        setStatusMessage("");
        setIsConverting(true);
        setServerLogs([]); // 초기화

        try {
            // Text Cache 처리
            const textResult = await handleImportProcess(() => LocliazeTextCacheDatabase(), 'Text Cache');
            if (!textResult.success) {
                setStatusMessage(`Text Cache 변환 실패: ${textResult.message}`);
                return;
            }

            const textLogs = Array.isArray(textResult.data.details)
                ? textResult.data.details
                : [textResult.data.details];

            setServerLogs(prevLogs => [
                ...prevLogs,
                "=== Text Cache 처리 결과 ===",
                ...textLogs
            ]);

            const imageResult = await handleImportProcess(() => LocliazeImageCacheDatabase(), 'Image Cache');
            if (!imageResult.success) {
                setStatusMessage(`Image Cache 변환 실패: ${imageResult.message}`);
                return;
            }

            const imageLogs = Array.isArray(imageResult.data.details)
                ? imageResult.data.details
                : [imageResult.data.details];

            // 두 번째 작업 로그 추가
            setServerLogs(prevLogs => [
                ...prevLogs,
                "",  // 구분을 위한 빈 줄
                "=== Image Cache 처리 결과 ===",
                ...imageLogs
            ]);

            setStatusMessage("모든 변환이 성공적으로 완료되었습니다.");

        } catch (error) {
            console.error('Error:', error);
            setError('변환 과정에서 오류가 발생했습니다.');
            setStatusMessage('변환 실패.');
        } finally {
            setIsConverting(false);
        }
    };


    return (
        <PageLayout
            title="Localize Text and Image Cache Database"
            description={
                <p className={`animated-text ${isConverting ? 'converting' : ''}`}>
                    {animatedText}
                </p>
            }
            onSubmit={handleConvert}
            isFileUpload={false}
            error={error}
            statusMessage={statusMessage}
            submitButtonText={isConverting ? "Localizing..." : "Localize"}
        >
            {/* children으로 서버 로그를 전달 */}
            {serverLogs.length > 0 && (
                <div className="server-logs-container">
                    <h3>서버 로그</h3>
                    <div className="server-logs">
                        {serverLogs.map((log, index) => (
                            <div key={index} className="log-line">
                                {log}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </PageLayout>
    );
}

export default LocalizeDatabase;